import { MsoLocationReport } from './../../model/mso-location-report';
import { Component, OnInit } from '@angular/core';
import { PdfFileService } from './../../services/pdf-file.service';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from './../../services/excel-file.service';
import { FileExportService } from './../../services/file-export.service';
import { ReportDateRangeDto } from './../../model/report-date-range-dto';
import { HttpclientService } from './../../services/httpclient.service';
import { MonthlyLocationDto } from './../../model/monthly-location-dto';
import { AppSettingService } from './../../services/app-setting.service';
import * as moment from 'moment';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
declare var $: any;
@Component({
  selector: 'app-location-report',
  templateUrl: './location-report.component.html',
  styleUrls: ['./location-report.component.css']
})
export class LocationReportComponent implements OnInit {

  maxMonthlyLocationDate: moment.Moment;
  monthlyLocationDateRange;
  monthlyLocationDateRangeStart;
  monthlyLocationDateRangeEnd;
  mlrExportModal: string;
  mlrSelectAllRowModal: boolean;
  public mlrloading: boolean;
  public mlrPaginationConfiguration;
  mlrPaginationcount = 25;
  msoLocationDtoList: MsoLocationReport[];
  initialmsoLocationDtoList: MsoLocationReport[];

  msoLocationDtoSelectedList: MsoLocationReport[];
  selectedmonthlyLocationDto: any = [];
  reportDateRangeDto: ReportDateRangeDto;
  numberofexecution = 0;
  clearMlrSelection: MonthlyLocationDto[];
  sortArry: MsoLocationReport[];

  msoHqNameSortCollapsedUpArrow: boolean;
  msoHqNameSortCollapsedDownArrow: boolean;
  msoSoldToSortCollapsedUpArrow: boolean;
  msoSoldToSortCollapsedDownArrow: boolean;
  msoNameSortCollapsedUpArrow: boolean;
  msoNameSortCollapsedDownArrow: boolean;
  msoStreetAddressSortCollapsedUpArrow: boolean;
  msoStreetAddressSortCollapsedDownArrow: boolean;
  msoCitySortCollapsedUpArrow: boolean;
  msoCitySortCollapsedDownArrow: boolean;
  msoStateSortCollapsedUpArrow: boolean;
  msoStateSortCollapsedDownArrow: boolean;
  msoZipSortCollapsedUpArrow: boolean;
  msoZipSortCollapsedDownArrow: boolean;
  servicingDistributorHqNameSortCollapsedUpArrow: boolean;
  servicingDistributorHqNameSortCollapsedDownArrow: boolean;
  servicingDistributorSoldToSortCollapsedUpArrow: boolean;
  servicingDistributorSoldToSortCollapsedDownArrow: boolean;
  servicingDistributorNameSortCollapsedUpArrow: boolean;
  servicingDistributorNameSortCollapsedDownArrow: boolean;
  servicingDistributorStreetAddressSortCollapsedUpArrow: boolean;
  servicingDistributorStreetAddressSortCollapsedDownArrow: boolean;
  servicingDistributorCitySortCollapsedUpArrow: boolean;
  servicingDistributorCitySortCollapsedDownArrow: boolean;
  servicingDistributorStateSortCollapsedUpArrow: boolean;
  servicingDistributorStateSortCollapsedDownArrow: boolean;
  servicingDistributorZipSortCollapsedUpArrow: boolean;
  servicingDistributorZipSortCollapsedDownArrow: boolean;

  selectedpartner;
  partners;
  loading;
  selectedPartnerName;
  searchData;

  constructor(public appSettingService: AppSettingService, private httpclientService: HttpclientService,
    public fileExportService: FileExportService, public excelFileService: ExcelFileService, public datePipe: DatePipe,
    public pdfFileService: PdfFileService, private pipe: PoOrderByPipe) { }

  ngOnInit() {
    this.msoLocationDtoList = [];
    this.mlrExportModal = this.appSettingService.exportList[0];
    this.maxMonthlyLocationDate = moment().add(0, 'days');
    this.mlrExportModal = this.appSettingService.exportList[0];
    this.mlrPaginationConfiguration = { currentPage: '25 per page', itemsPerPage: '25' };
    this.monthlyLocationDateRange = '';
    this.selectedpartner = '-1';
    this.getPartnerDataList();
    this.initialSortValue();
    this.msoLocationDateChange('0');
    $(document).ready(
      () => {
        let searchInp = $(".searchContr .searchInput");
        let searchCloseIcon = $(".searchCloseIcon")
        $(searchInp).on("focus", function () {
          $(".searchIcon").addClass("searchIconActive")
          $(".searchCloseIcon").fadeIn("slow")
        })
        $(searchInp).on("blur", function () {
          $(".searchIcon").removeClass("searchIconActive")
          $(".searchCloseIcon").fadeOut("slow")
        })
        $(searchCloseIcon).hover(function () {
          $(searchCloseIcon).toggleClass("searchCloseIconFocus")
        })
        $(searchCloseIcon).on("click", function () {
          $(".searchInput").val("");
        })

      }
    )
  }

  /****************************************************** Clear Selction Start ***************************************************/
  async onMsoChnage() {

    this.isBlank = '';
    this.searchData = '';
    if (this.selectedpartner !== '-1') {
      await  this.partners.forEach(element => {
        console.log(" this.element.partnerNumber.."+ element.partnerNumber+ '---->>'+this.selectedpartner);

        if (element.partnerNumber === this.selectedpartner) {
          this.selectedPartnerName = element.partnerName;
        }
        });

console.log(" this.selectedPartnerName.."+ this.selectedPartnerName);
      this.msoLocationDateChange(this.selectedPartnerName);
    } else {

      this.msoLocationDateChange('0');
      // this.initialmsoLocationDtoList = [];
      // this.msoLocationDtoList = [];
      this.selectedPartnerName = '';
    }
  }

  getPartnerDataList() {
    this.loading = true;
    if (this.appSettingService.customerMatlDropDownGlobelList === null || this.appSettingService.customerMatlDropDownGlobelList === undefined) {
      this.httpclientService.getCustomerMatlDropdownList().subscribe(
        data => {
          this.appSettingService.customerMatlDropDownGlobelList = data;
          this.partners = data;
          this.loading = false;
        }
      );

      console.log('Partner is null from backend' + this.appSettingService.customerMatlDropDownGlobelList);
    } else {
      this.partners = this.appSettingService.customerMatlDropDownGlobelList;
      this.loading = false;
      console.log('Partner is not null from frontend' + this.appSettingService.customerMatlDropDownGlobelList);
    }
  }

  cancelsearch() {
    this.isBlank = ""
    this.msoLocationDtoList = this.initialmsoLocationDtoList;
  }
  initialSortValue() {
    this.msoHqNameSortCollapsedUpArrow = true;
    this.msoHqNameSortCollapsedDownArrow = true;
    this.msoSoldToSortCollapsedUpArrow = true;
    this.msoSoldToSortCollapsedDownArrow = true;
    this.msoNameSortCollapsedUpArrow = true;
    this.msoNameSortCollapsedDownArrow = true;
    this.msoStreetAddressSortCollapsedUpArrow = true;
    this.msoStreetAddressSortCollapsedDownArrow = true;
    this.msoCitySortCollapsedUpArrow = true;
    this.msoCitySortCollapsedDownArrow = true;
    this.msoStateSortCollapsedUpArrow = true;
    this.msoStateSortCollapsedDownArrow = true;
    this.msoZipSortCollapsedUpArrow = true;
    this.msoZipSortCollapsedDownArrow = true;
    this.servicingDistributorHqNameSortCollapsedUpArrow = true;
    this.servicingDistributorHqNameSortCollapsedDownArrow = true;
    this.servicingDistributorSoldToSortCollapsedUpArrow = true;
    this.servicingDistributorSoldToSortCollapsedDownArrow = true;
    this.servicingDistributorNameSortCollapsedUpArrow = true;
    this.servicingDistributorNameSortCollapsedDownArrow = true;
    this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
    this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
    this.servicingDistributorCitySortCollapsedUpArrow = true;
    this.servicingDistributorCitySortCollapsedDownArrow = true;
    this.servicingDistributorStateSortCollapsedUpArrow = true;
    this.servicingDistributorStateSortCollapsedDownArrow = true;
    this.servicingDistributorZipSortCollapsedUpArrow = true;
    this.servicingDistributorZipSortCollapsedDownArrow = true;
  }
  clearAllSelection() {
    this.mlrSelectAllRowModal = false;
    this.initialSortValue();
    // this.clearMlrSelection = [];
    // this.monthlyLocationDtoList.forEach(pdto => {
    //   pdto.rowCheck = false;
    //   this.clearMlrSelection.push(pdto);
    // });
    // this.monthlyLocationDtoList = this.clearMlrSelection;
  }
  /****************************************************** Clear Selction End ***************************************************/

  /****************************************************** Table Sort Start ***************************************************/
  ChangeMlrSortOrder(exportData) {
    this.mlrExportModal = exportData;
  }

  isBlank: string = "";
  onSearch(searchingData) {
    if (searchingData.value === "" || searchingData.value === undefined || searchingData.value === null) {
      this.isBlank = "Please Enter Searching Data";
      return;
    }
    var filteredSerachDetails: MsoLocationReport[] = [];
    var inputSearchingData = searchingData.value.toUpperCase();
    var inputSearchingDataCheck = inputSearchingData;
    var msoHqName, msoSoldTo, servicingDistributorHqName, servicingDistributorSoldTo;
    for (var msoLocationReport of this.msoLocationDtoList) {
      if (msoLocationReport.msoHqName != null && msoLocationReport.msoHqName != undefined && msoLocationReport.msoHqName != "") {
        msoHqName = msoLocationReport.msoHqName.toUpperCase();
      } else {
        msoHqName = "";
      }
      if (msoLocationReport.msoSoldTo != null && msoLocationReport.msoSoldTo != undefined && msoLocationReport.msoSoldTo != "") {
        msoSoldTo = msoLocationReport.msoSoldTo.toUpperCase();
      } else {
        msoSoldTo = "";
      }
      if (msoLocationReport.servicingDistributorHqName != null && msoLocationReport.servicingDistributorHqName != undefined && msoLocationReport.servicingDistributorHqName != "") {
        servicingDistributorHqName = msoLocationReport.servicingDistributorHqName.toUpperCase();
      } else {
        servicingDistributorHqName = "";
      }
      if (msoLocationReport.servicingDistributorSoldTo != null && msoLocationReport.servicingDistributorSoldTo != undefined && msoLocationReport.servicingDistributorSoldTo != "") {
        servicingDistributorSoldTo = msoLocationReport.servicingDistributorSoldTo.toUpperCase();
      } else {
        servicingDistributorSoldTo = "";
      }
      if (msoHqName.includes(inputSearchingDataCheck)) {
        filteredSerachDetails.push(msoLocationReport);
      }
      else if (msoSoldTo.includes(inputSearchingDataCheck)) {
        filteredSerachDetails.push(msoLocationReport);
      }
      else if (servicingDistributorHqName.includes(inputSearchingDataCheck)) {
        filteredSerachDetails.push(msoLocationReport);
      }
      else if (servicingDistributorSoldTo.includes(inputSearchingDataCheck)) {
        filteredSerachDetails.push(msoLocationReport);
      }
    }
    let size = filteredSerachDetails.length;
    if (size != 0) {
      this.msoLocationDtoList = [];
      this.msoLocationDtoList = filteredSerachDetails;
    } else {
      this.isBlank = "No Record Found";
      this.msoLocationDtoList = this.initialmsoLocationDtoList;
    }

  }

  onChangeMlrSort(event: any, upDown: boolean, propertyName: string) {
    if (propertyName === 'msoHqName') {
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, upDown);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoHqNameSortCollapsedUpArrow = !this.msoHqNameSortCollapsedUpArrow;
        this.msoHqNameSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, upDown);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoHqNameSortCollapsedDownArrow = !this.msoHqNameSortCollapsedDownArrow;
        this.msoHqNameSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'msoSoldTo') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoSoldToSortCollapsedUpArrow = !this.msoSoldToSortCollapsedUpArrow;
        this.msoSoldToSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoSoldToSortCollapsedDownArrow = !this.msoSoldToSortCollapsedDownArrow;
        this.msoSoldToSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'msoName') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoNameSortCollapsedUpArrow = !this.msoNameSortCollapsedUpArrow;
        this.msoNameSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoNameSortCollapsedDownArrow = !this.msoNameSortCollapsedDownArrow;
        this.msoNameSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'msoStreetAddress') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;
      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoStreetAddressSortCollapsedUpArrow = !this.msoStreetAddressSortCollapsedUpArrow;
        this.msoStreetAddressSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoStreetAddressSortCollapsedDownArrow = !this.msoStreetAddressSortCollapsedDownArrow;
        this.msoStreetAddressSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'msoCity') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoCitySortCollapsedUpArrow = !this.msoCitySortCollapsedUpArrow;
        this.msoCitySortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoCitySortCollapsedDownArrow = !this.msoCitySortCollapsedDownArrow;
        this.msoCitySortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'msoState') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoStateSortCollapsedUpArrow = !this.msoStateSortCollapsedUpArrow;
        this.msoStateSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoStateSortCollapsedDownArrow = !this.msoStateSortCollapsedDownArrow;
        this.msoStateSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'msoZip') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoZipSortCollapsedUpArrow = !this.msoZipSortCollapsedUpArrow;
        this.msoZipSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.msoZipSortCollapsedDownArrow = !this.msoZipSortCollapsedDownArrow;
        this.msoZipSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'servicingDistributorHqName') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorHqNameSortCollapsedUpArrow = !this.servicingDistributorHqNameSortCollapsedUpArrow;
        this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorHqNameSortCollapsedDownArrow = !this.servicingDistributorHqNameSortCollapsedDownArrow;
        this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'servicingDistributorSoldTo') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorSoldToSortCollapsedUpArrow = !this.servicingDistributorSoldToSortCollapsedUpArrow;
        this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorSoldToSortCollapsedDownArrow = !this.servicingDistributorSoldToSortCollapsedDownArrow;
        this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'servicingDistributorName') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorNameSortCollapsedUpArrow = !this.servicingDistributorNameSortCollapsedUpArrow;
        this.servicingDistributorNameSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorNameSortCollapsedDownArrow = !this.servicingDistributorNameSortCollapsedDownArrow;
        this.servicingDistributorNameSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'servicingDistributorStreetAddress') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorStreetAddressSortCollapsedUpArrow = !this.servicingDistributorStreetAddressSortCollapsedUpArrow;
        this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorStreetAddressSortCollapsedDownArrow = !this.servicingDistributorStreetAddressSortCollapsedDownArrow;
        this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'servicingDistributorCity') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorCitySortCollapsedUpArrow = !this.servicingDistributorCitySortCollapsedUpArrow;
        this.servicingDistributorCitySortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorCitySortCollapsedDownArrow = !this.servicingDistributorCitySortCollapsedDownArrow;
        this.servicingDistributorCitySortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'servicingDistributorState') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorZipSortCollapsedUpArrow = true;
      this.servicingDistributorZipSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorStateSortCollapsedUpArrow = !this.servicingDistributorStateSortCollapsedUpArrow;
        this.servicingDistributorStateSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorStateSortCollapsedDownArrow = !this.servicingDistributorStateSortCollapsedDownArrow;
        this.servicingDistributorStateSortCollapsedUpArrow = true;
      }
    } else if (propertyName === 'servicingDistributorZip') {
      this.msoHqNameSortCollapsedUpArrow = true;
      this.msoHqNameSortCollapsedDownArrow = true;
      this.msoSoldToSortCollapsedUpArrow = true;
      this.msoSoldToSortCollapsedDownArrow = true;
      this.msoNameSortCollapsedUpArrow = true;
      this.msoNameSortCollapsedDownArrow = true;
      this.msoStreetAddressSortCollapsedUpArrow = true;
      this.msoStreetAddressSortCollapsedDownArrow = true;
      this.msoCitySortCollapsedUpArrow = true;
      this.msoCitySortCollapsedDownArrow = true;
      this.msoStateSortCollapsedUpArrow = true;
      this.msoStateSortCollapsedDownArrow = true;
      this.msoZipSortCollapsedUpArrow = true;
      this.msoZipSortCollapsedDownArrow = true;
      this.servicingDistributorHqNameSortCollapsedUpArrow = true;
      this.servicingDistributorHqNameSortCollapsedDownArrow = true;
      this.servicingDistributorSoldToSortCollapsedUpArrow = true;
      this.servicingDistributorSoldToSortCollapsedDownArrow = true;
      this.servicingDistributorNameSortCollapsedUpArrow = true;
      this.servicingDistributorNameSortCollapsedDownArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedUpArrow = true;
      this.servicingDistributorStreetAddressSortCollapsedDownArrow = true;
      this.servicingDistributorCitySortCollapsedUpArrow = true;
      this.servicingDistributorCitySortCollapsedDownArrow = true;
      this.servicingDistributorStateSortCollapsedUpArrow = true;
      this.servicingDistributorStateSortCollapsedDownArrow = true;

      if (upDown) {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, true);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;

        this.servicingDistributorZipSortCollapsedUpArrow = !this.servicingDistributorZipSortCollapsedUpArrow;
        this.servicingDistributorZipSortCollapsedDownArrow = true;
      } else {
        this.sortArry = [];
        this.sortArry = this.pipe.transform(this.msoLocationDtoList, propertyName, false);
        this.msoLocationDtoList = [];
        this.msoLocationDtoList = this.sortArry;
        this.servicingDistributorZipSortCollapsedDownArrow = !this.servicingDistributorZipSortCollapsedDownArrow;
        this.servicingDistributorZipSortCollapsedUpArrow = true;
      }
    }


  }

  /****************************************************** Table Sort End ***************************************************/


  /****************************************************** Row Selection Start ***************************************************/
  mlrOnSelectParticularRow(selectedItem: any, values: any) {
    if (values.currentTarget.checked) {
      this.fileExportService.selectedMsoLocationReportData.push(selectedItem);
    } else if (!values.currentTarget.checked) {
      this.fileExportService.selectedMsoLocationReportData =
        this.fileExportService.selectedMsoLocationReportData.filter(obj => obj !== selectedItem);
    }
    if (this.fileExportService.selectedMsoLocationReportData.length === this.msoLocationDtoList.length) {
      this.mlrSelectAllRowModal = true;
    } else {
      this.mlrSelectAllRowModal = false;
    }
  }

  mlrOnSelectAllRow(values: any) {
    this.msoLocationDtoSelectedList = [];
    if (values.currentTarget.checked) {
      this.msoLocationDtoList.forEach(pdto => {
        pdto.rowCheck = true;
        this.msoLocationDtoSelectedList.push(pdto);
      });
      this.msoLocationDtoList = this.msoLocationDtoSelectedList;
      this.fileExportService.selectedMsoLocationReportData = this.msoLocationDtoSelectedList;
    } else {
      this.msoLocationDtoList.forEach(pdto => {
        pdto.rowCheck = false;
        this.msoLocationDtoSelectedList.push(pdto);
      });
      this.msoLocationDtoList = this.msoLocationDtoSelectedList;
      this.fileExportService.selectedMsoLocationReportData = [];
    }
  }
  /****************************************************** Row Selection End ***************************************************/

  /****************************************************** Date Picker Block Start ***************************************************/
  msoLocationDateChange(partnerName) {
    this.fileExportService.selectedMsoLocationReportData = [];
    this.clearAllSelection();

    this.mlrloading = true;
    this.httpclientService.getmsoLocationDateChange(partnerName).subscribe(
      data => {
        this.mlrloading = false;
        this.clearAllSelection();
        this.initialmsoLocationDtoList = data;
        this.msoLocationDtoList = data;
      }
    );

  }
  /****************************************************** Date Picker Block End ***************************************************/

  /****************************************************** File Export Start ***************************************************/
  modalPopup: boolean = false;
  modalPopupString: string;
  pressingOK() {
    this.modalPopup = false;
  }
  clearMessage() {
    this.isBlank = ""
  }
  copyOfItemErrorDescription: string = "";
  msoExportFile() {
    if (this.msoLocationDtoList == null || this.msoLocationDtoList == undefined || this.msoLocationDtoList.length === 0) {
      this.modalPopupString = "No Data to Export";
      this.modalPopup = true;
      return;
    } //else {
    let todayDate = new Date();
    let dateAndTime = this.datePipe.transform(todayDate, '_MM/dd/yyyy_HH:mm:ss').toString();
    console.log(dateAndTime);
    let flag: boolean = false;

    if (this.fileExportService.selectedMsoLocationReportData.length === 0) {
      flag = true;
      this.selectedmonthlyLocationDto = [];
      this.msoLocationDtoList.forEach(pdto => {
        pdto.rowCheck = true;
        this.selectedmonthlyLocationDto.push(pdto);
      });
      this.msoLocationDtoList = this.selectedmonthlyLocationDto;
      this.fileExportService.selectedMsoLocationReportData = this.selectedmonthlyLocationDto;
    }


    if (this.mlrExportModal === 'PDF') {
      this.pdfFileService.exportMsoLocationReport('MSO Location Report' + dateAndTime);
    } else if (this.mlrExportModal === 'Excel') {
      this.selectedmonthlyLocationDto = [];
      this.fileExportService.selectedMsoLocationReportData.forEach(pdto => {

        if (pdto.rowCheck) {
          if (pdto.msoHqName == null || pdto.msoHqName == undefined || pdto.msoHqName == "") {
            pdto.msoHqName = "";
          }
          if (pdto.msoSoldTo == null || pdto.msoSoldTo == undefined || pdto.msoSoldTo == "") {
            pdto.msoSoldTo = "";
          }
          if (pdto.msoName == null || pdto.msoName == undefined || pdto.msoName == "") {
            pdto.msoName = "";
          }
          if (pdto.msoStreetAddress == null || pdto.msoStreetAddress == undefined || pdto.msoStreetAddress == "") {
            pdto.msoStreetAddress = "";
          }
          if (pdto.msoCity == null || pdto.msoCity == undefined || pdto.msoCity == "") {
            pdto.msoCity = "";
          }
          if (pdto.msoState == null || pdto.msoState == undefined || pdto.msoState == "") {
            pdto.msoState = "";
          }
          if (pdto.msoZip == null || pdto.msoZip == undefined || pdto.msoZip == "") {
            pdto.msoZip = "";
          }
          if (pdto.servicingDistributorHqName == null || pdto.servicingDistributorHqName == undefined || pdto.servicingDistributorHqName == "") {
            pdto.servicingDistributorHqName = "";
          }
          if (pdto.servicingDistributorSoldTo == null || pdto.servicingDistributorSoldTo == undefined || pdto.servicingDistributorSoldTo == "") {
            pdto.servicingDistributorSoldTo = "";
          }
          if (pdto.servicingDistributorName == null || pdto.servicingDistributorName == undefined || pdto.servicingDistributorName == "") {
            pdto.servicingDistributorName = "";
          }
          if (pdto.servicingDistributorStreetAddress == null || pdto.servicingDistributorStreetAddress == undefined || pdto.servicingDistributorStreetAddress == "") {
            pdto.servicingDistributorStreetAddress = "";
          }
          if (pdto.servicingDistributorCity == null || pdto.servicingDistributorCity == undefined || pdto.servicingDistributorCity == "") {
            pdto.servicingDistributorCity = "";
          }
          if (pdto.servicingDistributorState == null || pdto.servicingDistributorState == undefined || pdto.servicingDistributorState == "") {
            pdto.servicingDistributorState = "";
          }
          if (pdto.servicingDistributorZip == null || pdto.servicingDistributorZip == undefined || pdto.servicingDistributorZip == "") {
            pdto.servicingDistributorZip = "";
          }
          this.selectedmonthlyLocationDto.push({
            'MSO HQ Name': `${pdto.msoHqName}`, 'MSO Sold-to': `${pdto.msoSoldTo}`,
            'MSO Name': `${pdto.msoName}`, 'MSO Street Address': `${pdto.msoStreetAddress}`,
            'MSO City': `${pdto.msoCity}`, 'MSO State': `${pdto.msoState}`,
            'MSO Zip': `${pdto.msoZip}`, 'Servicing Distributor HQ Name': `${pdto.servicingDistributorHqName}`,
            'Servicing Distributor Sold-to': `${pdto.servicingDistributorSoldTo}`, 'Servicing Distributor Name': `${pdto.servicingDistributorName}`,
            'Servicing Distributor Street Address': `${pdto.servicingDistributorStreetAddress}`, 'Servicing Distributor City': `${pdto.servicingDistributorCity}`,
            'Servicing Distributor State': `${pdto.servicingDistributorState}`, 'Servicing Distributor Zip': `${pdto.servicingDistributorZip}`,

          });
        }
      });
      this.excelFileService.exportMonthlyLocationReportExcel(this.selectedmonthlyLocationDto, 'MSO Location Report' + dateAndTime);
    }
    // }
    if (flag) {
      this.selectedmonthlyLocationDto = [];
      this.msoLocationDtoList.forEach(pdto => {
        pdto.rowCheck = false;
        this.selectedmonthlyLocationDto.push(pdto);
      });
      this.msoLocationDtoList = this.selectedmonthlyLocationDto;
      this.fileExportService.selectedMsoLocationReportData = [];
    }
  }
  /****************************************************** File Export End ***************************************************/

  /****************************************************** Pagination Start ***************************************************/
  mlrOnChangePagination(value) {

    this.mlrPaginationConfiguration.itemsPerPage = value;
    this.mlrPaginationcount = value;
  }

  mlrPageOnChanged(event) {
    this.mlrPaginationConfiguration.currentPage = event;
  }
  /****************************************************** Pagination End ***************************************************/

}



